import { useQuery } from '@tanstack/react-query';
import API from '../Job/API';
import { IError } from '../SmartForms/types';

export const usePlaceholders = ({
  type,
  onError
}: {
  type: string;
  onError: (message: string) => void;
}) => {
  return useQuery({
    queryKey: ['placeholders', type],
    queryFn: async () => {
      const res = await API.getPlaceholders(type);
      return res.placeholders;
    },
    onError: (error: IError) => onError(error.errors.join(', '))
  });
};
